import sendToDataLayer from '../tracking/dataLayer';
import { AnalyticsConfig } from '../types/configs';

const queueObject = (config: AnalyticsConfig) => {
  let queue: any[] = [];

  const isEmpty = () => queue.length < 1;
  const peek = () => queue[0];
  const get = () => queue;

  /**
   * Dequeue Function
   * @returns
   */
  const dequeue = (newConfig?: any) => {
    if (isEmpty()) return queueObject(config);
    const item = peek();
    sendToDataLayer(item, newConfig);

    queue = queue.slice(1);

    // eslint-disable-next-line no-use-before-define
    runQueue(newConfig);
    return queueObject(config);
  };

  /**
   * TODO
   * The last time runQueue, the queue will become 0 isEmpty becomes TRUE.
   */
  const runQueue = async (newConfig?: any) => {
    dequeue(newConfig);
  };

  /**
   * Enqueue Function
   * @returns
   */
  const enqueue = (item: object) => {
    queue = [...queue, item];
    runQueue(config);
    return queueObject(config); // Return the object context instead of `this`
  };

  return {
    enqueue,
    dequeue,
    runQueue,
    get,
    peek,
    isEmpty,
  };
};

const queue = (config: any) => {
  if (
    !config.analyticsDataObject.dataLayer ||
    !Array.isArray(config.analyticsDataObject.dataLayer)
  ) {
    throw new Error(
      'QAL Error: analyticsDataObject is required and must be an array'
    );
  }

  const queueResult = queueObject(config);

  return queueResult;
};

export default queue;
